module.exports = __webpack_public_path__ + "static/media/sock-anim-no-zoom.11ff73fa.webm";